<template>
  <v-container fluid grid-list-md v-if="plans !== null && plans !== undefined">
    <v-layout row justify-center>
      <v-flex xs12 sm6 md4 lg3>
        <v-card
          v-if="
            (isLoggedIn &&
              (role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Broker Plan Manager') > -1)) ||
            role.indexOf('Employer Plan Admin') > -1 ||
            role.indexOf('Documents Management Admin') > -1 ||
            role.indexOf('Employer Members Viewer') > -1 ||
            role.indexOf('Member Portal Admin') > -1 ||
            role.indexOf('Member Portal Users Admin') > -1
          "
        >
          <v-card-text>
            <auto-select
              style="min-width: 200px"
              clear-icon="clear"
              v-model="selected.Plan"
              :items="plans"
              :label="$t('views.selectplan.select_plan')"
              :loading="loading"
              :slots="true"
              :filter="filterFunc"
              itemValue="Id"
            >
              <template v-slot:selection="data">
                {{ planDescription(data.item) }}
                <span :class="statusClass(data.item)">
                  {{ status(data.item) }}
                </span>
              </template>
              <template v-slot:item="data">
                <v-list-item-content
                  v-text="planDescription(data.item)"
                ></v-list-item-content>
                <span :class="statusClass(data.item)">
                  {{ status(data.item) }}
                </span>
              </template>
            </auto-select>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <error-handler :error="error"></error-handler>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { translate2 } from "../trans2";
import AutoSelect from "../components/AutoSelect";

export default {
  components: {
    ErrorHandler,
    AutoSelect,
  },
  data() {
    return {
      error: null,
      broker: null,
      selected: {
        Plan: null,
      },
      loading: true,
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["plan", "plans"]),
  },
  watch: {
    "selected.Plan": {
      async handler(v) {
        if (v) {
          try {
            console.log("Select-Plan: watch: plan: ", this.selected.Plan);
            this.setPlan(this.selected.Plan);
            await this.getPlanOptions(this.selected.Plan.Id);
            this.$router.push({
              name: "homeWithPlan",
              params: { planId: this.selected.Plan.Id },
            });
          } catch (error) {
            this.error = error;
          }
        }
      },
    },
    plans: {
      handler(v) {
        if (v) this.loading = false;
      },
    },
  },
  created() {
    //this.initialize()
  },
  async mounted() {
    if (this.isLoggedIn) {
      try {
        await this.loadUserPlans();
        this.selected.Plan = this.$store.getters["common/plan"];
        if (
          this.$route.params.plan !== null &&
          this.$route.params.plan !== undefined
        ) {
          this.selected.Plan = this.plans.filter(
            (p) => p.name === this.$route.params.plan
          )[0];
        }
      } catch (error) {
        console.log(error);
      }
      if (this.plans) this.loading = false;
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getPlanOptions", "getUserPlans"]),
    ...mapActions("auth", ["getUser", "silentRefresh", "login"]),
    ...mapActions("common", ["setPlan", "setPlans"]),
    filterFunc(item, search) {
      return (
        this.planDescription(item).toLowerCase().indexOf(search.toLowerCase()) >
        -1
      );
    },
    status(item) {
      if (item === null || item === undefined) return "";
      return item.Current.IsTesting ? " Test " : " Live ";
    },
    statusClass(item) {
      // console.log("statusClass: ", item);
      if (item === null || item === undefined) return "";
      return item.Current.IsTesting ? "test-plan" : "live-plan";
    },
    async loadUserPlans() {
      try {
        var usr = await this.silentRefresh();
        if (usr) {
          let plans = (await this.getUserPlans()).data.value;
          this.setPlans(
            plans.map((o) => {
              o.Name = o.Current.Name;
              o.Description = o.Current.Description;
              o.Translations = o.Current.Translations;
              return o;
            })
          );
          if (plans.length === 1) {
            this.setPlan(plans[0]);
          }
          if (this.plan) {
            this.selected.Plan = this.plan;
          }
        }
      } catch (error) {
        //console.log("selectPlan: silent refresh error: ", error);
        this.login();
      }
    },
    planDescription(plan) {
      const desc = translate2(plan, "Name");
      if (desc.indexOf(plan.UniqueIdentifier) === 0) {
        return desc;
      }
      return plan.UniqueIdentifier + "-" + desc;
    },
  },
};
</script>

<style></style>
